import { genericService } from "./genericService";


const section = "StockWarehouse";
function getStockByWarehouse(warehouseId) {
  return genericService.get(section + "/GetStockByWarehouse/" + warehouseId);
}

function findContainer(numContainer) {
  return genericService.get(section + "/FindContainer/" + numContainer);
}

export const stockWarehouseService = {
  getStockByWarehouse,
  findContainer,
};
